import { html, ViewTemplate, ref } from '@microsoft/fast-element';
import type { ClosePopup } from './close-popup';

export const ClosePopupTemplate: ViewTemplate<ClosePopup> = html`
  <fast-dialog class="close-dialog" part="close-dialog" ${ref('closeDialog')}>
    <div class="text-container">
      <p class="header">${(x) => x.header}</p>
      <p class="description">${(x) => x.description}</p>
    </div>
    <div class="button-container">
      <zero-button type="button" class="cancel" @click="${(x) => x.cancelCloseDialog()}">
        Cancel
      </zero-button>

      <zero-button class="confirm" type="button" @click="${(x) => x.confirmCloseDialog()}">
        Proceed
      </zero-button>
    </div>
  </fast-dialog>
`;
